import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=b2883d02&scoped=true&"
import script from "./Toolbar.vue?vue&type=script&lang=ts&"
export * from "./Toolbar.vue?vue&type=script&lang=ts&"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=b2883d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2883d02",
  null
  
)

export default component.exports